import * as React from 'react'
import { UploadWatcherListConnected } from './UploadWatcherListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const UploadWatcherListExamples = () => {
  return (
    <div className="UploadWatcherListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UploadWatcherListConnected />
      </Provider>
    </div>
  )
}
